import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';

type State =
    | { kind: 'loading' }
    | { kind: 'success'; firstName: string; lastName: string; stageName: string }
    | { kind: 'error'; message: string };

const SsoCallbackPage = () => {
    const [state, setState] = useState<State>({ kind: 'loading' });
    const history = useHistory();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
        const returnedState = params.get('state');

        if (!token) {
            setState({ kind: 'error', message: 'No sign-in token received.' });
            return;
        }

        try {
            const expected = sessionStorage.getItem('ssoState');
            if (expected && returnedState && expected !== returnedState) {
                setState({
                    kind: 'error',
                    message: 'Sign-in flow state mismatch. Please try again.',
                });
                return;
            }
            sessionStorage.removeItem('ssoState');
        } catch (_) {}

        axios
            .post('/api/sso/exchange', { token })
            .then((r) => {
                const g = r.data.guest;
                if (!r.data.profileComplete) {
                    try {
                        sessionStorage.setItem('ssoToken', token);
                        sessionStorage.setItem(
                            'ssoStageName',
                            g.stageName || ''
                        );
                    } catch (_) {}
                    history.replace('/sso/complete-profile');
                    return;
                }
                setState({
                    kind: 'success',
                    firstName: g.firstName,
                    lastName: g.lastName,
                    stageName: g.stageName,
                });
            })
            .catch((err) => {
                const msg =
                    err?.response?.data?.message ||
                    err?.message ||
                    'Unable to verify sign-in. Please try again.';
                setState({ kind: 'error', message: msg });
            });
    }, [history]);

    if (state.kind === 'loading') {
        return (
            <div style={{ padding: 32, textAlign: 'center' }}>
                <h2>Checking you in…</h2>
            </div>
        );
    }

    if (state.kind === 'error') {
        return (
            <div style={{ padding: 32, textAlign: 'center' }}>
                <h2>Sign-in failed</h2>
                <p>{state.message}</p>
                <p>
                    <a href="/sso/start">Try again</a>
                </p>
            </div>
        );
    }

    return (
        <div style={{ padding: 32, textAlign: 'center' }}>
            <h2>You're checked in!</h2>
            <p>
                Welcome, <strong>{state.stageName || state.firstName}</strong>.
                Porky's staff has you on tonight's roster.
            </p>
        </div>
    );
};

export default SsoCallbackPage;
